import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import HttpClient from '@/util/http/HttpClient';
import DirectNavigationItemTranslation from '@/repositories/data/directnavigation/DirectNavigationItemTranslation';

export default class DirectNavigationItemTranslationRepository extends BaseCrudRepository<
    number,
    DirectNavigationItemTranslation,
    DirectNavigationItemTranslation
> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/direct-navigation-item-translation/');
    }
}
